class SiyaStickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.mainButton = document.querySelector(
      '.product-information product-form-component .add-to-cart-button'
    );

    if (!this.mainButton) return;

    this.stickyButton = this.querySelector('[data-sticky-add]');
    this.stickyButton?.addEventListener('click', this.handleAdd);
    this.closest('.shopify-section')?.addEventListener('variant:update', this.handleVariantUpdate);

    this.observer = new IntersectionObserver(this.handleIntersection, { threshold: 0 });
    this.observer.observe(this.mainButton);
    this.syncButton();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.stickyButton?.removeEventListener('click', this.handleAdd);
    this.closest('.shopify-section')?.removeEventListener('variant:update', this.handleVariantUpdate);
  }

  handleIntersection = ([entry]) => {
    const hasScrolledPastButton = entry.boundingClientRect.bottom < 0;
    this.hidden = entry.isIntersecting || !hasScrolledPastButton;
  };

  handleAdd = () => {
    if (!this.mainButton?.disabled) this.mainButton.click();
  };

  handleVariantUpdate = (event) => {
    const replacement = event.detail?.html?.querySelector('[data-siya-sticky-cart]');
    const variant = event.detail?.resource;

    if (replacement) {
      const image = replacement.querySelector('.siya-sticky-cart__image');
      const currentImage = this.querySelector('.siya-sticky-cart__image');
      if (image && currentImage) currentImage.replaceWith(image.cloneNode(true));

      for (const selector of [
        '[data-sticky-variant]',
        '[data-sticky-price]',
        '[data-sticky-mobile-price]',
      ]) {
        const current = this.querySelector(selector);
        const updated = replacement.querySelector(selector);
        if (current && updated) current.replaceWith(updated.cloneNode(true));
      }
    }

    if (this.stickyButton && variant) {
      this.stickyButton.disabled = !variant.available;
      const text = this.querySelector('[data-sticky-add-text]');
      const updatedText = replacement?.querySelector('[data-sticky-add-text]');
      if (text && updatedText) text.textContent = updatedText.textContent;
    }

    requestAnimationFrame(() => {
      this.mainButton = document.querySelector(
        '.product-information product-form-component .add-to-cart-button'
      );
      this.syncButton();
    });
  };

  syncButton() {
    if (!this.mainButton || !this.stickyButton) return;
    this.stickyButton.disabled = this.mainButton.disabled;
  }
}

if (!customElements.get('siya-sticky-add-to-cart')) {
  customElements.define('siya-sticky-add-to-cart', SiyaStickyAddToCart);
}
